import { http } from './config'

export default {

  getAllPalletProducts: () => {
    return http.get('pallet_products')
  },

  getAllPalletProductsByPalletTypeAndLocality: (params) => {
    return http.get('pallet_products/by_pallet_type_and_locality/', { params })
  },

  createPalletProduct: (params) => {
    return http.post('pallet_products', {
      pallet_product:
        {
          pallet_type_id: params.pallet_type_id,
          product_id: params.product_id,
          locality_id: params.locality_id,
        },
    })
  },

  addAllProducts: (params) => {
    return http.post(`pallet_products/addAllProducts/?pallet_type_id=${params.pallet_type_id}&locality_id=${params.locality_id}`)
  },

  removeAllProducts: (params) => {
    return http.delete(`pallet_products/removeAllProducts/?pallet_type_id=${params.pallet_type_id}&locality_id=${params.locality_id}`)
  },

  removePalletProduct: (id) => {
    return http.delete('pallet_products/' + id)
  },

}
